export default __webpack_public_path__ + "static/media/photo--lg--chris-5.eddac209.jpg";